module.exports = __webpack_public_path__ + "static/media/CS1O1_EP5.2e84530a.png";